(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'crestone-email-popup-dismissed';
    var dialog = document.getElementById('email-popup');
    if (!dialog) return;

    var testMode = new URLSearchParams(window.location.search).has('test-popup');
    var alreadyDismissed = testMode ? false : window.localStorage.getItem(STORAGE_KEY);
    var justSucceeded = dialog.hasAttribute('data-posted-successfully');

    function dismiss() {
      window.localStorage.setItem(STORAGE_KEY, '1');
      if (dialog.open) dialog.close();
    }

    dialog.querySelectorAll('[data-email-popup-close]').forEach(function (button) {
      button.addEventListener('click', dismiss);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dismiss();
    });

    dialog.addEventListener('cancel', function () {
      window.localStorage.setItem(STORAGE_KEY, '1');
    });

    if (justSucceeded) {
      dialog.classList.add('email-popup--success');
      window.localStorage.setItem(STORAGE_KEY, '1');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    if (alreadyDismissed) return;
    if (typeof dialog.showModal !== 'function') return;

    window.setTimeout(function () {
      dialog.showModal();
    }, 4000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    sections.forEach(function (section) {
      section.classList.add('scroll-reveal-pending');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('scroll-reveal-pending');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
